import React, { useEffect, useState } from 'react';
import { Modal } from '@mui/material';
import SelectionsBadge from './SelectionsBadge';
import { format } from 'date-fns';
import DataSearchAPI from 'api/DataSearch';
import DateSelector from 'components/Screening/filters/DateSelector';
import Snackbar, { SnackbarCloseReason } from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import ModalLayout from './ModalLayout';

interface IFiltersProps {
  filters: any;
  setFilters: any;
  userHasEntitySearch: any;
  entityState: any;
  setEntityState: any;
  commodityState: any;
  setCommodityState: any;
  cur_user: any;

}

const FiltersDescUI: React.FC<IFiltersProps> = ({ userHasEntitySearch, entityState, setEntityState, commodityState, setCommodityState, filters, setFilters, cur_user,
}) => {
  const [ filterMode, setFilterMode ] = useState<boolean>(false);
  const [ filterName, setFilterName ] = useState<string>('');
  const [ filterNameOpen, setFilterNameOpen ] = useState(false);
  const [ deleteFilterOpen, setDeleteFilterOpen ] = useState(false);
  const [ deleteId, setDeleteId ] = useState('');
  const [ appliedFilter, setAppliedFilter ] = useState<any>({});
  const [ canSaveFilter, setCanSaveFilter ] = useState<boolean>(false);
  const [ openDate, setOpenDate ] = useState(false);
  const [ createSuccess, setCreateSuccess ] = React.useState(false);
  const [ updateSuccess, setUpdateSuccess ] = React.useState(false);
  const [ failNotify, setFailNotify ] = React.useState(false);
  const [ tab, setTab ] = useState('Entities');
  const [ submit, setSubmit ] = useState<any>({
    trigger: false,
    reason: '',
    location: ''
  });

  const handleNotify = (reason: string) => {
    if (reason === 'create') {
      setCreateSuccess(true);
    } else if (reason === 'update') {
      setUpdateSuccess(true);
    } else {
      setFailNotify(true);
    }
  };

  const handleCloseNotify = (
    event?: React.SyntheticEvent | Event,
    reason?: SnackbarCloseReason,
  ) => {
    if (reason === 'clickaway') {
      return;
    }

    setCreateSuccess(false);
    setUpdateSuccess(false);
    setFailNotify(false);
  };

  const handleFilterNameChange = (e: any) => {
    setFilterName(e.target.value);
  };

  const handleFilterNameClose = () => {
    setFilterNameOpen(false);
    setFilterName('');
  };


  const handleDateChange = (newValue: any) => {
    const arr: any = [ ...newValue ];
    if (newValue !== null) {
      arr.forEach((dt: any, index: number) => {
        if (dt !== null) {
          const dtWithoutTz = new Date(dt.valueOf() + dt.getTimezoneOffset() * 60 * 1000);
          const formatted_dt = format(dtWithoutTz, 'yyyy-MM-dd');
          arr[index] = formatted_dt;
        }
      });
    }
    setEntityState({ ...entityState, date: newValue, dateRange: arr });
    setCommodityState({ ...commodityState, date: newValue, dateRange: arr });
  };

  const handleClear = () => {
    setEntityState({
      fuzzy: false,
      date: null,
      dateRange: [],
      lenses: [],
      agencies: [],
      countries: [],
      lists: []
    });
    setCommodityState({
      fuzzy: false,
      date: null,
      dateRange: [],
      lenses: [],
      agencies: [],
      countries: [],
      lists: []
    });
    setSubmit({ reason: 'apply', trigger: !submit.trigger, location: 'Entity' });
    setAppliedFilter({});
    setCanSaveFilter(false);
  };


  const saveFilter = async() => {
    setFilters({ ...filters, isLoaded: false });
    const query = {
      userId: cur_user.basics.id,
      groupId: cur_user.selected_team.id,
      filterName: filterName,
      type: 'entity',
      lenses: entityState.lenses,
      countries: entityState.countries,
      agencies: entityState.agencies,
      lists: entityState.lists,
      entRes: entityState.fuzzy,
    };
    const res = await DataSearchAPI.createSearchFilter({ newSearchFilter: query });
    setFilters({ isLoaded: true, arr: [ ...filters.arr, res?.result ] });
    if (res?.success) {
      handleNotify('create');
    } else {
      handleNotify('fail');
    }
  };

  const updateFilter = async() => {
    setFilters({ ...filters, isLoaded: false });
    const query = {
      ...appliedFilter,
      lenses: entityState.lenses,
      countries: entityState.countries,
      agencies: entityState.agencies,
      lists: entityState.lists,
      entRes: entityState.fuzzy,
    };
    const res = await DataSearchAPI.updateSearchFilter({ update: query });
    if (res?.success) {
      handleNotify('update');
      const index = filters.arr.map((filt: any, i: number) => {
        if (filt._id === res.result._id) {
          return i;
        }
      });
      const array = [ ...filters.arr ];
      array[index[0]] = res.result;
      setFilters({ isLoaded: true, arr: array });
    } else {
      handleNotify('fail');
    }
  };

  const deleteFitler = async(id: string) => {
    const res = await DataSearchAPI.deleteSearchFilter(id);
    if (res?.success) {
      const arr = filters.arr.filter((filt: any) => {
        return filt._id !== id;
      });
      setFilters({ isLoaded: true, arr: arr });
    }
  };

  useEffect(() => {
    if (entityState.agencies.length > 0) {
      setCanSaveFilter(true);
    }
    if (entityState.countries.length > 0) {
      setCanSaveFilter(true);
    }
    if (entityState.lenses.length > 0) {
      setCanSaveFilter(true);
    }
    if (entityState.lists.length > 0) {
      setCanSaveFilter(true);
    }
  }, [ entityState ]);


  return (
    <div className={`screening-filters-container-full ${!userHasEntitySearch ? 'os-iframe-blur' : ''}`}>
      <div className='screening-lens-container'>
        <div className='screening-lens-body'>
          <div className='filter-selection-box' onClick={() => {
            setTab('Entities');
            setFilterMode(true);
          }}>
            <div className='filter-ui-cont'>
              <svg xmlns='http://www.w3.org/2000/svg' width='16' height='15' viewBox='0 0 16 15' fill='none'>
                <path d='M1.25 14C3.00184 12.1419 5.38026 11 8 11C10.6197 11 12.9982 12.1419 14.75 14M11.375 4.625C11.375 6.48896 9.86396 8 8 8C6.13604 8 4.625 6.48896 4.625 4.625C4.625 2.76104 6.13604 1.25 8 1.25C9.86396 1.25 11.375 2.76104 11.375 4.625Z' stroke='#EFF1F6' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round'/>
              </svg>
              <div className='filter-ui-head-text'>
              People & Companies
              </div>
              {(entityState.lenses.length > 0 || entityState.countries.length > 0 || entityState.agencies.length > 0 || entityState.lists.length > 0) && (
                <SelectionsBadge selections={entityState.lenses.length + entityState.countries.length + entityState.agencies.length + entityState.lists.length} />
              )}
              <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
                <path d='M9.17 7.00005C8.98375 7.18741 8.87921 7.44087 8.87921 7.70505C8.87921 7.96924 8.98375 8.22269 9.17 8.41005L12.71 12.0001L9.17 15.5401C8.98375 15.7274 8.87921 15.9809 8.87921 16.2451C8.87921 16.5092 8.98375 16.7627 9.17 16.9501C9.26297 17.0438 9.37357 17.1182 9.49543 17.1689C9.61729 17.2197 9.74799 17.2458 9.88 17.2458C10.012 17.2458 10.1427 17.2197 10.2646 17.1689C10.3864 17.1182 10.497 17.0438 10.59 16.9501L14.83 12.7101C14.9237 12.6171 14.9981 12.5065 15.0489 12.3846C15.0997 12.2628 15.1258 12.1321 15.1258 12.0001C15.1258 11.868 15.0997 11.7373 15.0489 11.6155C14.9981 11.4936 14.9237 11.383 14.83 11.2901L10.59 7.00005C10.497 6.90632 10.3864 6.83193 10.2646 6.78116C10.1427 6.73039 10.012 6.70425 9.88 6.70425C9.74799 6.70425 9.61729 6.73039 9.49543 6.78116C9.37357 6.83193 9.26297 6.90632 9.17 7.00005Z' fill='#EFF1F6'/>
              </svg>
            </div>
            <div className='filter-ui-desc-text'>
          Choose filters relating to people and companies: Lens, Listing Country, Agency, List, Date, and Entity Resolution
            </div>
          </div>
          <div className='filter-divider'></div>
          <div className='filter-selection-box' onClick={() => {
            setTab('Commodities');
            setFilterMode(true);
          }}>
            <div className='filter-ui-cont'>
              <svg xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 18 18' fill='none'>
                <path d='M15.375 5.45776L8.99998 8.99943M8.99998 8.99943L2.62498 5.45776M8.99998 8.99943L9 16.1245M15.75 12.0434V5.95554C15.75 5.69855 15.75 5.57006 15.7121 5.45546C15.6786 5.35408 15.6239 5.26102 15.5515 5.1825C15.4697 5.09375 15.3574 5.03135 15.1328 4.90655L9.58277 1.82321C9.37007 1.70505 9.26372 1.64596 9.15109 1.6228C9.05141 1.6023 8.9486 1.6023 8.84891 1.6228C8.73628 1.64596 8.62993 1.70505 8.41723 1.82322L2.86723 4.90655C2.64259 5.03135 2.53026 5.09375 2.44847 5.18251C2.37612 5.26102 2.32136 5.35408 2.28786 5.45547C2.25 5.57007 2.25 5.69856 2.25 5.95554V12.0434C2.25 12.3004 2.25 12.4288 2.28786 12.5434C2.32136 12.6448 2.37612 12.7379 2.44847 12.8164C2.53026 12.9052 2.64259 12.9676 2.86723 13.0924L8.41723 16.1757C8.62993 16.2939 8.73628 16.3529 8.84891 16.3761C8.9486 16.3966 9.05141 16.3966 9.15109 16.3761C9.26372 16.3529 9.37007 16.2939 9.58277 16.1757L15.1328 13.0924C15.3574 12.9676 15.4697 12.9052 15.5515 12.8164C15.6239 12.7379 15.6786 12.6448 15.7121 12.5434C15.75 12.4288 15.75 12.3004 15.75 12.0434Z' stroke='#EFF1F6' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round'/>
                <path d='M12.375 7.125L5.625 3.375' stroke='#EFF1F6' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
              </svg>
              <div className='filter-ui-head-text'>
              Commodities & Products
              </div>
              {(commodityState?.comLenses?.length > 0 || commodityState?.countries?.length > 0 || commodityState?.agencies?.length > 0 || commodityState?.lists?.length > 0) && (
                <SelectionsBadge selections={commodityState?.comLenses?.length + commodityState?.countries?.length + commodityState?.agencies?.length + commodityState?.lists?.length} />
              )}
              <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
                <path d='M9.17019 6.99981C8.98394 7.18717 8.87939 7.44062 8.87939 7.70481C8.87939 7.96899 8.98394 8.22244 9.17019 8.40981L12.7102 11.9998L9.17019 15.5398C8.98394 15.7272 8.87939 15.9806 8.87939 16.2448C8.87939 16.509 8.98394 16.7624 9.17019 16.9498C9.26315 17.0435 9.37375 17.1179 9.49561 17.1687C9.61747 17.2195 9.74818 17.2456 9.88019 17.2456C10.0122 17.2456 10.1429 17.2195 10.2648 17.1687C10.3866 17.1179 10.4972 17.0435 10.5902 16.9498L14.8302 12.7098C14.9239 12.6168 14.9983 12.5062 15.0491 12.3844C15.0998 12.2625 15.126 12.1318 15.126 11.9998C15.126 11.8678 15.0998 11.7371 15.0491 11.6152C14.9983 11.4934 14.9239 11.3828 14.8302 11.2898L10.5902 6.99981C10.4972 6.90608 10.3866 6.83169 10.2648 6.78092C10.1429 6.73015 10.0122 6.70401 9.88019 6.70401C9.74818 6.70401 9.61747 6.73015 9.49561 6.78092C9.37375 6.83169 9.26315 6.90608 9.17019 6.99981Z' fill='#EFF1F6'/>
              </svg>
            </div>
            <div className='filter-ui-desc-text'>
          Choose filters relating to commodities and products: Lens, Country Regulator, Agency, List, HS Code, Date, and Entity Resolution
            </div>
          </div>
          <div className='filter-divider'></div>
        </div>
      </div>

      <Modal
        open={filterMode}
        onClose={() => setFilterMode(false)}
      >
        <ModalLayout
          setFilterMode={setFilterMode}
          submit={submit}
          setSubmit={setSubmit}
          entityState={entityState}
          setEntityState={setEntityState}
          commodityState={commodityState}
          setCommodityState={setCommodityState}
          appliedFilter={appliedFilter}
          handleClear={handleClear}
          updateFilter={updateFilter}
          setOpenDate={setOpenDate}
          openTab={tab}
        />
      </Modal>
      <Modal
        open={openDate}
        onClose={() => setOpenDate(false)}
      >
        <DateSelector
          openDate={openDate}
          setOpenDate={setOpenDate}
          state={entityState}
          handleDateChange={handleDateChange}
          setSubmit={setSubmit}
          submit={submit}
        />
      </Modal>
      <Modal
        open={filterNameOpen}
        onClose={handleFilterNameClose}
      >
        <div className='screening-filter-modal'>
          <div className='screening-filter-modal-icons'>
            <div className='filter-icon-svg'>
              <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
                <path d='M6 12H18M3 6H21M9 18H15' stroke='#4895EF' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
              </svg>
            </div>
            <svg style={{ cursor: 'pointer' }} onClick={handleFilterNameClose} xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
              <path d='M18 6L6 18M6 6L18 18' stroke='#85888E' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
            </svg>
          </div>
          <div className='screening-filter-modal-title'>
            <h2>Name Filter</h2>
            <h3>Please enter a name for this filter.</h3>
          </div>
          <div className='screening-filter-modal-input'>
            <h4>Filter name</h4>
            <div className='screening-input-field-container' >
              <input
                id='modal-input'
                type='text'
                className='screening-input-field-content'
                name='modal-input'
                value={filterName}
                onChange={handleFilterNameChange}
              />
            </div>
          </div>
          <div className='screening-filter-modal-btns'>
            <div className='filters-clear-btn' onClick={() => {
              handleFilterNameClose();
            }}>
              <div className='filters-clear-btn-text' >
                Cancel
              </div>
            </div>
            <div className='filters-save-btn'
              onClick={() => {
                if (filterName.length > 0) {
                  saveFilter();
                  handleFilterNameClose();
                }
              }}>
              <div className='filters-save-btn-text'>
                Confirm
              </div>
            </div>
          </div>
        </div>
      </Modal>
      <Modal
        open={deleteFilterOpen}
        onClose={() => {
          setDeleteFilterOpen(false);
          setDeleteId('');
        }}
      >
        <div className='screening-filter-modal'>
          <div className='screening-filter-modal-icons'>
            <div className='filter-icon-svg-delete'>
              <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
                <path d='M16 6V5.2C16 4.0799 16 3.51984 15.782 3.09202C15.5903 2.71569 15.2843 2.40973 14.908 2.21799C14.4802 2 13.9201 2 12.8 2H11.2C10.0799 2 9.51984 2 9.09202 2.21799C8.71569 2.40973 8.40973 2.71569 8.21799 3.09202C8 3.51984 8 4.0799 8 5.2V6M10 11.5V16.5M14 11.5V16.5M3 6H21M19 6V17.2C19 18.8802 19 19.7202 18.673 20.362C18.3854 20.9265 17.9265 21.3854 17.362 21.673C16.7202 22 15.8802 22 14.2 22H9.8C8.11984 22 7.27976 22 6.63803 21.673C6.07354 21.3854 5.6146 20.9265 5.32698 20.362C5 19.7202 5 18.8802 5 17.2V6' stroke='#F04438' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
              </svg>
            </div>
            <svg style={{ cursor: 'pointer' }} onClick={() => {
              setDeleteFilterOpen(false);
              setDeleteId('');
            }} xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
              <path d='M18 6L6 18M6 6L18 18' stroke='#85888E' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
            </svg>
          </div>
          <div className='screening-filter-modal-title'>
            <h2>Delete Filter</h2>
            <h3>Are you sure you wish to delete this filter? This action cannot be undone.</h3>
          </div>
          <div className='screening-filter-modal-btns'>
            <div className='filters-clear-btn' onClick={() => {
              setDeleteFilterOpen(false);
              setDeleteId('');
            }}>
              <div className='filters-clear-btn-text' >
                Cancel
              </div>
            </div>
            <div className='filters-save-btn-delete' onClick={() => {
              deleteFitler(deleteId);
              setDeleteId('');
              setDeleteFilterOpen(false);
            }}>
              <div className='filters-save-btn-text'>
                Delete
              </div>
            </div>
          </div>
        </div>
      </Modal>
      <Snackbar open={createSuccess} autoHideDuration={5000} onClose={handleCloseNotify}>
        <Alert
          onClose={handleCloseNotify}
          severity='success'
          variant='filled'
          sx={{ width: '100%' }}
        >
          Filter was Successfully Created!
        </Alert>
      </Snackbar>
      <Snackbar open={updateSuccess} autoHideDuration={5000} onClose={handleCloseNotify}>
        <Alert
          onClose={handleCloseNotify}
          severity='success'
          variant='filled'
          sx={{ width: '100%' }}
        >
          Filter was Successfully Updated!
        </Alert>
      </Snackbar>
      <Snackbar open={failNotify} autoHideDuration={5000} onClose={handleCloseNotify}>
        <Alert
          onClose={handleCloseNotify}
          severity='error'
          variant='filled'
          sx={{ width: '100%' }}
        >
          Failed to connect the server, please try again or contact the BITE Team.
        </Alert>
      </Snackbar>
    </div>
  );
};

export default FiltersDescUI;
